/**
 * Holds 2 types of blocking data stored in DB
 */
export enum BlockingType {
    NEVER_AFTER_DAY, // means that data could be edited during 24 hours after creation and then it freezed
    AFTER_DAY_WITH_COMMIT, // means that data could be edited anytime but with tracking all changes
}
